var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        ref: "formValidation",
        attrs: { slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ invalid }) {
              return [
                _c(
                  "form",
                  {
                    staticClass: "form-horizontal",
                    attrs: {
                      role: "form",
                      name: "apiTokenForm",
                      novalidate: ""
                    },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.onSave.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("fieldset", [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "NAME",
                                expression: "'NAME'"
                              }
                            ],
                            staticClass: "col-sm-3 col-md-3 control-label"
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  "tooltip-class": "tooltip-white",
                                  "tooltip-placement": "right",
                                  "tooltip-append-to-body": "true"
                                }
                              },
                              [
                                _vm._v("\n                "),
                                _c("i", {
                                  staticClass: "fa fa-question-circle"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-4 col-md-2" },
                          [
                            _c(
                              "ValidationProvider",
                              { attrs: { rules: "required", slim: "" } },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.apiToken.name,
                                      expression: "apiToken.name"
                                    },
                                    { name: "focus", rawName: "v-focus" }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    required: "",
                                    type: "text",
                                    name: "name",
                                    "custom-autofocus": "true",
                                    placeholder: "Name"
                                  },
                                  domProps: { value: _vm.apiToken.name },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.apiToken,
                                        "name",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3"
                          },
                          [
                            _c("button", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "ADD_BUTTON_TEXT",
                                  expression: "'ADD_BUTTON_TEXT'"
                                }
                              ],
                              staticClass: "btn btn-primary btn-sm",
                              attrs: { type: "button", disabled: invalid },
                              on: { click: _vm.onSave }
                            }),
                            _vm._v(" "),
                            _c("button", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "CANCEL_BUTTON_TEXT",
                                  expression: "'CANCEL_BUTTON_TEXT'"
                                }
                              ],
                              staticClass: "btn btn-sm btn-danger m-l-15",
                              attrs: { type: "button" },
                              on: { click: _vm.closeForm }
                            })
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.showConfirmation
                      ? _c(
                          "ConfirmationModal",
                          {
                            attrs: {
                              entity: _vm.apiToken,
                              title: _vm.$t("API_TOKEN_SUCCESS"),
                              "cancel-button-text": _vm.$t("CLOSE"),
                              "confirm-custom-action-text": _vm.$t(
                                "COPY_TOKEN"
                              ),
                              "show-confirm-button": false,
                              "show-header-close-button": false,
                              "show-custom-button": true,
                              "allow-modal-to-be-closed": _vm.tokenHasBeenCopied
                            },
                            on: {
                              "custom-action": _vm.copyToken,
                              close: _vm.onCloseApiTokenModal
                            }
                          },
                          [
                            _c("span", [
                              _c("i", {
                                staticClass: "p-0 typcn yellow typcn-warning",
                                attrs: { "tooltip-placement": "left" }
                              }),
                              _vm._v(" "),
                              _c("label", {
                                directives: [
                                  {
                                    name: "t",
                                    rawName: "v-t",
                                    value:
                                      "CREATED_TOKEN_STORE_SAFE_LOCATION_WARNING",
                                    expression:
                                      "'CREATED_TOKEN_STORE_SAFE_LOCATION_WARNING'"
                                  }
                                ]
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "m-t-10 m-b-10 well well-sm" },
                              [
                                _c("span", { staticClass: "token-content" }, [
                                  _c("b", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.createdApiTokenResponse.token
                                        ) +
                                        " "
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "checkbox f-s-14" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.tokenHasBeenCopied,
                                      expression: "tokenHasBeenCopied"
                                    }
                                  ],
                                  staticClass: "m-t-4",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.tokenHasBeenCopied
                                    )
                                      ? _vm._i(_vm.tokenHasBeenCopied, null) >
                                        -1
                                      : _vm.tokenHasBeenCopied
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.tokenHasBeenCopied,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.tokenHasBeenCopied = $$a.concat(
                                              [$$v]
                                            ))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.tokenHasBeenCopied = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.tokenHasBeenCopied = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "I_HAVE_COPIED_THE_TOKEN",
                                      expression: "'I_HAVE_COPIED_THE_TOKEN'"
                                    }
                                  ]
                                })
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }